import { createBrowserRouter } from "react-router-dom";
import { SearchComponentLatest } from "../Pages/SearchList/SearchComponentLatest";
import BookmarksPage from "../Pages/Bookmarks/BookmarksPage";
import ResumePage from "../Pages/Resume/ResumePage";
import Error404Page from "../Pages/Error404";
import HnHiring from "../Pages/HnHiring/HnHiring";
import HnHiringResume from "../Pages/Resume/HnHiringResume";



export const router = createBrowserRouter([
  {
    path: "/",
    element: <SearchComponentLatest />,
  },
  {
    path: "hnhiring",
    element: <HnHiring />,
  },
  {
    path: "searchlatest",
    element: <SearchComponentLatest />,
  },
  {
    path: "bookmarks",
    element: <BookmarksPage />,
  },
  {
    path: "resume",
    element: <ResumePage />,
  },
  {
    path: "hnhiring-resume",
    element: <HnHiringResume />,
  },
  {
    path: "*",
    element: <Error404Page />,
  },
]);